import React from "react";
import SourceConfidenceBadge from "./SourceConfidenceBadge";

/** Arrow and wording for each direction of travel. */
const TREND_LABELS = {
  up: { icon: "▲", label: "Improving", className: "is-up" },
  flat: { icon: "▬", label: "Stable", className: "is-flat" },
  down: { icon: "▼", label: "Declining", className: "is-down" },
};

/**
 * Compares the company against its peer group on headline figures.
 *
 * @param {{payload: object|null}} props - The completed peer-landscape section.
 * @returns {JSX.Element|null} The table, or nothing until the section completes.
 */
const PeerLandscapeTable = ({ payload }) => {
  if (!payload?.rows?.length) return null;

  const ordered = [...payload.rows].sort(
    (a, b) => Number(b.isBaseCompany) - Number(a.isBaseCompany),
  );

  return (
    <section className="aica-card">
      <div className="aica-card-head">
        <div>
          <h2>Peer landscape</h2>
          <p className="aica-sub">
            Benchmarked against your selected competitors, latest reported year.
          </p>
        </div>
      </div>

      <div className="aica-table-wrap">
        <table className="aica-table">
          <thead>
            <tr>
              <th>Company</th>
              <th>ESG score</th>
              <th>Scope 1+2</th>
              <th>Renewable energy</th>
              <th>Net-zero target</th>
              <th>Trend</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {ordered.map((row) => {
              const trend = TREND_LABELS[row.trend] || TREND_LABELS.flat;
              return (
                <tr
                  key={row.name}
                  className={row.isBaseCompany ? "is-base-company" : ""}
                >
                  <td>
                    <span className="aica-company">
                      <span className="aica-avatar">{row.shortCode}</span>
                      <span>
                        <span className="aica-company-name">{row.name}</span>
                        {row.isBaseCompany && (
                          <span className="aica-you">YOU</span>
                        )}
                      </span>
                    </span>
                  </td>
                  <td className="aica-num">{row.esgScore}</td>
                  <td className="aica-num">{row.scope12Intensity}</td>
                  <td className="aica-num">{row.renewablePct}%</td>
                  <td className="aica-num">{row.netZeroTarget}</td>
                  <td>
                    <span className={`aica-trend ${trend.className}`}>
                      {trend.icon} {trend.label}
                    </span>
                  </td>
                  <td>
                    <SourceConfidenceBadge provenance={row.provenance} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default PeerLandscapeTable;
